import styled from 'styled-components'

export const VideoDetailsBgContainer = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: none;
`

export const NonHeaderContainer = styled.div`
  display: flex;
  overflow: auto;
  height: 100%;
  background-color: ${props => (props.darkMode ? '#181818' : '#f9f9f9')};
`
